module.exports = __webpack_public_path__ + "img/Multi-Device.0c4a10cf.jpg";